import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://7vtxaf-x1.myshopify.com/cart/45821756342458:1';
export function Identification() {
  return <section className="w-full bg-gray-50 py-20 md:py-32 px-4" data-id="element-56">
      <div className="max-w-4xl mx-auto text-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-58">
          <p className="text-2xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-59">
            Sabés lo que tenés que hacer. Pero no lo hacés.
          </p>

          <p className="text-2xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-60">
            Postergás. Te distraés. Arrancás… y abandonás.
          </p>

          <p className="text-2xl md:text-4xl font-bold text-gray-900 mb-12" data-id="element-61">
            No es falta de ganas. Es falta de un{' '}
            <span className="bg-yellow-400 px-2" data-id="element-62">sistema</span>.
          </p>

          <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold text-xl md:text-2xl px-12 py-6 rounded-xl shadow-2xl transition-all duration-300 w-full md:w-auto" data-id="element-63">
            QUIERO DEJAR DE PROCRASTINAR
          </motion.a>
        </motion.div>
      </div>
    </section>;
}